export const CONTACT = {
  // Move this into the CMS or environment settings before production launch.
  whatsappNumber: "2349076529048",
  phone: "+234 907 652 9048",
  email: "hello@maplecc.ca",
};

export const SOCIAL_LINKS: { network: "instagram" | "facebook" | "x"; label: string; url: string }[] = [
  { network: "instagram", label: "Instagram", url: "https://www.instagram.com/maplecanadiancollege/" },
  { network: "facebook", label: "Facebook", url: "https://web.facebook.com/maplecanadiancollege/" },
  { network: "x", label: "X (Twitter)", url: "https://x.com/CollegeMaple" },
];

export const NAV_ITEMS = [
  { label: "About", href: "#about" },
  { label: "Academics", href: "#academics" },
  { label: "Student Life", href: "#life" },
  { label: "Admissions", href: "#admissions" },
  { label: "Stories", href: "#stories" },
];

export const DIFFERENCE_PANELS = [
  {
    number: "01",
    title: "Ontario Secondary School Diploma",
    copy: "A clear Canadian pathway, delivered in Lagos.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/3729e6fb-9c77-4813-a265-5c72c62aaebb.jpg",
  },
  {
    number: "02",
    title: "University preparation",
    copy: "Purposeful learning for the next academic chapter.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/36e90b70-8b5d-4978-aece-353bc5939b6a.jpg",
  },
  {
    number: "03",
    title: "Student support",
    copy: "High expectations, with people who know each student.",
    image: "https://cdn.magicpatterns.com/patterns/generated-images/46263d87-bfe9-441b-ac8d-69cb13f5aa75.jpg",
  },
];

export const ADMISSIONS_STEPS = [
  ["01", "Discover MCC", "See whether the MCC environment and Grade 10–12 focus are right for your child."],
  ["02", "Understand the programme", "Explore the OSSD pathway, learning experience and student support."],
  ["03", "Speak to Admissions", "Get answers from the MCC team before making a decision."],
  ["04", "Apply", "Move forward when you and your family are ready."],
] as const;

export const ASK_MAPLE_ACTIONS = ["Admissions", "OSSD", "Fees", "Boarding", "University pathways", "Campus visit"];
